import { API_URL } from "../config/apiConfig";

const request = async (path, options = {}) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/base-contracts${path}`, {
        ...options,
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

    const contentType = response.headers.get("content-type") || "";
    const data = response.status === 204
        ? null
        : contentType.includes("application/json")
            ? await response.json()
            : await response.text();

    if (!response.ok) {
        const message = data?.message || data?.error || (typeof data === "string" && data) ||
            `Request failed with status ${response.status}`;
        throw new Error(message);
    }

    return data;
};

export const getBaseContracts = () => request("");

export const createBaseContract = (baseContract) => request("", {
    method: "POST",
    body: JSON.stringify(baseContract),
});

export const updateBaseContract = (id, baseContract) => request(`/${id}`, {
    method: "PUT",
    body: JSON.stringify(baseContract),
});

export const deleteBaseContract = (id) => request(`/${id}`, {
    method: "DELETE",
});

export const getAffiliateBaseContracts = (affiliateId) =>
    request(`/affiliate/${affiliateId}`);

export const previewBaseContractJoin = (id, { startDate, paymentDay }) =>
    request(`/${id}/preview`, {
        method: "POST",
        body: JSON.stringify({ startDate, paymentDay }),
    });

export const joinBaseContract = (id, joinData) => request(`/${id}/join`, {
    method: "POST",
    body: JSON.stringify(joinData),
});
